import { GoogleAuthProvider, signInWithRedirect } from 'firebase/auth';

const HandleGoogle = async (auth) => {
  const provider = new GoogleAuthProvider();
  try {
    await signInWithRedirect(auth, provider);
  } catch {
    console.error('Google authentication error');
  }
};

export default HandleGoogle;
